<!--Copyright (c) Laserfiche.
Licensed under the MIT License. See LICENSE in the project root for license information.-->

<mat-form-field title="{{ lf_field_info.displayName }}" appearance="outline" class="lf-field lf-dropdown">
  <mat-select
    panelClass="lf-dropdown-overlay"
    [formControl]="lf_field_form_control"
    title="{{ lf_field_form_control.value }}"
    (selectionChange)="onValueChanged()"
  >
    <mat-option>--</mat-option>
    @for (listOption of listOptions; track listOption) {
      <mat-option [value]="listOption">
        {{ listOption }}
      </mat-option>
    }
  </mat-select>
  @if (getBrokenValidationRule()) {
    <mat-error>{{ fieldValidationErrorMsg | async }}</mat-error>
  }
</mat-form-field>
